import React from 'react';

import { AVAILABILITY_COLUMN } from '../constants';

const HEADERS: { column: number; label: string; align?: string }[] = [
	{ column: AVAILABILITY_COLUMN.rs, label: 'RS' },
	{ column: AVAILABILITY_COLUMN.atc, label: 'ATC' },
	{ column: AVAILABILITY_COLUMN.brand, label: 'NÁZEV LP' },
	{ column: AVAILABILITY_COLUMN.pack, label: 'DOPLNĚK NÁZVU' },
	{ column: AVAILABILITY_COLUMN.suklCode, label: 'SÚKL KÓD', align: 'text-right' },
	{ column: AVAILABILITY_COLUMN.share, label: 'DOSTUPNOST' },
	{ column: AVAILABILITY_COLUMN.dncDou, label: 'DNC/DoÚ', align: 'text-center' },
	{ column: AVAILABILITY_COLUMN.status, label: 'STAV', align: 'text-center' },
];

export interface TableHeaderProps {
	/** Must be the same track list the body grid uses. */
	columns: string;
}

/**
 * Sticky column header of the availability table, shown from `xl` up where the list
 * becomes a grid. Below that the layout stacks and each cell labels itself.
 *
 * This is a grid of its own rather than a row of the body grid: a sticky grid item is
 * clamped to its own grid area, so a header cell placed in row 1 would only travel the
 * height of that row before scrolling away. As a separate sibling its containing block
 * is the whole list, so it stays pinned for the full table. The two grids stay in step
 * because every track is sized independently of its content, so equal widths always
 * resolve to equal columns.
 *
 * Deliberately carries no table ARIA roles: the RS and ATC cells span their whole group
 * and so cannot be DOM children of a `role="row"`, which would make partial roles here
 * describe an invalid table.
 *
 * @param {TableHeaderProps} props the shared column track list.
 * @returns {JSX.Element} the sticky header row.
 */
export function TableHeader({ columns }: TableHeaderProps) {
	return (
		<div
			className='hidden xl:grid sticky z-10 bg-gray-100 pt-1 pb-2 border-b border-gray-300'
			style={{ gridTemplateColumns: columns, top: 'var(--availability-filters-h, 120px)' }}
		>
			{HEADERS.map(({ column, label, align }) => (
				<div
					key={label}
					style={{ gridColumn: column }}
					className={`text-[0.8em] text-gray-500 leading-tight${column === AVAILABILITY_COLUMN.status ? '' : ' pr-6'}${
						align ? ` ${align}` : ''
					}`}
				>
					{label}
				</div>
			))}
		</div>
	);
}
